module.exports = __webpack_public_path__ + "static/hand-mobile-7f938363398a8437333846b6caefbfb0.svg";